// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/**
 * Skeleton loader component for the time records table.
 * Displays while time record data is being fetched from the API.
 */
export function TimeRecordTableSkeleton() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Person</TableCell>
            <TableCell align="right">Hours</TableCell>
            <TableCell align="right">Rate</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell>Project</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Description</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[1, 2, 3, 4, 5].map((index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton width={100} />
              </TableCell>
              <TableCell>
                <Skeleton width={120} />
              </TableCell>
              <TableCell align="right">
                <Skeleton width={60} />
              </TableCell>
              <TableCell align="right">
                <Skeleton width={70} />
              </TableCell>
              <TableCell align="right">
                <Skeleton width={80} />
              </TableCell>
              <TableCell>
                <Skeleton width={200} />
              </TableCell>
              <TableCell>
                <Skeleton width={100} />
              </TableCell>
              <TableCell>
                <Skeleton width={220} />
              </TableCell>
              <TableCell align="center">
                <Skeleton width={24} height={24} sx={{ mx: 'auto' }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
